import { LOGIN_FIREBASE } from "../../apis/user";
export default {
  data() {
    return {
      uiConfig: {},
      firebaseConfig: {
        apiKey: "AIzaSyDABDnpbMXPkL7vOtGcnrkYABaut50hX7A",
        authDomain: "pluspercent-charge.firebaseapp.com",
        projectId: "pluspercent-charge",
        storageBucket: "pluspercent-charge.firebasestorage.app",
        messagingSenderId: "170563368908",
        appId: "1:170563368908:web:b9b0afd416f1477d100f69",
        measurementId: "G-82M9SREW0L"
      }
    };
  },
  methods: {
    // Initialize Firebase JS SDK
    initFirebaseJsSdk() {
      firebase.initializeApp(this.firebaseConfig);
      firebase.analytics();
      const auth = firebase.auth();
      auth.languageCode = "ja";
      window.ui = new firebaseui.auth.AuthUI(auth);
      this.loadUi();
    },
    loadUi() {
      let vm = this;
      this.uiConfig = {
        callbacks: {
          signInSuccessWithAuthResult: function(authResult, redirectUrl) {
            console.log("signInSuccessWithAuthResult", authResult, redirectUrl);
            let user = authResult.user;
            user
              .getIdToken()
              .then(accessToken => {
                vm.$post(
                  LOGIN_FIREBASE,
                  {
                    idToken: accessToken,
                    uid: authResult.user.uid,
                    displayName: authResult.user.displayName,
                    email: authResult.user.email,
                    photoUrl: authResult.user.photoURL,
                    phoneNumber: authResult.user.phoneNumber,
                    inviteCode: vm.inviteCode
                  },
                  res => {
                    vm.$store.commit("token", res.token);
                    vm.loadUser();
                  },
                  err => {
                    console.log("err", err);
                  },
                  { headers: { "Content-Type": "application/json" } }
                );
                console.log("accessToken", accessToken);
              })
              .catch(err => {
                console.log("accessToken err", err);
                return false;
              });
            // User successfully signed in.
            // Return type determines whether we continue the redirect automatically
            // or whether we leave that to developer to handle.
            return false;
          },
          uiShown: function() {
            // The widget is rendered.
            // Hide the loader.
            vm.$loading(false);
            document.getElementById("loader").style.display = "none";
          }
        },
        // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
        signInFlow: "popup",
        signInSuccessUrl: "/",
        signInOptions: [
          // Leave the lines as is for the providers you want to offer your users.
          // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
          // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
          // firebase.auth.GithubAuthProvider.PROVIDER_ID,
          // firebase.auth.EmailAuthProvider.PROVIDER_ID,
          {
            provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
            defaultCountry: "JP",
            recaptchaParameters: { hl: "ja" }
          }
        ],
        // Terms of service url.
        tosUrl: `${process.env.VUE_APP_DOMAIN}/content/user_agreement.html`,
        // Privacy policy url.
        privacyPolicyUrl: `${process.env.VUE_APP_DOMAIN}/content/privacy_policy.html`
      };
      window.ui.start("#firebaseui-auth-container", this.uiConfig);
    },
    loadFirebaseScript() {
      if (!window.firebase) {
        let loadScript = window.document.createElement("script");
        loadScript.src =
          "https://www.gstatic.com/firebasejs/8.10.1/firebase-app.js";
        let loadScript2 = window.document.createElement("script");
        loadScript2.src =
          "https://www.gstatic.com/firebasejs/8.10.1/firebase-analytics.js";
        let loadScript3 = window.document.createElement("script");
        loadScript3.src =
          "https://www.gstatic.com/firebasejs/8.10.1/firebase-auth.js";
        let loadScript4 = window.document.createElement("script");
        loadScript4.src =
          "https://www.gstatic.com/firebasejs/ui/6.1.0/firebase-ui-auth.js";
        var head =
          window.document.head ||
          window.document.getElementsByTagName("head")[0] ||
          window.document.documentElement;
        loadScript.onload = () => {
          loadScript2.onload = () => {
            this.loadScriptVal += 1;
          };
          loadScript3.onload = () => {
            this.loadScriptVal += 1;
          };
          loadScript4.onload = () => {
            this.loadScriptVal += 1;
          };
          head.insertBefore(loadScript4, head.firstChild);
          head.insertBefore(loadScript3, head.firstChild);
          head.insertBefore(loadScript2, head.firstChild);
        };
        head.insertBefore(loadScript, head.firstChild);
      } else {
        this.loadUi();
      }
    }
  }
};
